import { NotFoundPage } from '~/components/common';
import {
  CallsPageAdmin,
  DashboardPageAdmin,
  ErrorLogsPageAdmin,
  FunnelPageAdmin,
  LocationPageAdmin,
  PermissionsPageAdmin,
  ProtectModePageAdmin,
  SafetyAlertsPageAdmin,
  SignInPageAdmin,
  SupportRequestsPageAdmin,
} from '~/pages/admin';
import { IRouteModel } from '../interface/common';

export const adminRoute = {
  base: '/admin',
  login: '/login',
  dashboard: '/dashboard',
  funnel: '/funnel',
  permissions: '/permissions',
  protectMode: '/protect-mode',
  calls: '/calls',
  location: '/location',
  safetyAlerts: '/safety-alerts',
  errorLogs: '/error-logs',
  supportRequests: '/support-requests',
};

export const publicAdminRoutes: IRouteModel[] = [
  {
    path: '*',
    component: NotFoundPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.login}`,
    component: SignInPageAdmin,
  },
];

// `name` holds an i18n key (nav.*) rather than display text - Sidebar renders it via t().
export const privateAdminRoutes: IRouteModel[] = [
  {
    path: `${adminRoute.base}${adminRoute.dashboard}`,
    component: DashboardPageAdmin,
    name: 'nav.dashboard',
  },
  {
    path: `${adminRoute.base}${adminRoute.funnel}`,
    component: FunnelPageAdmin,
    name: 'nav.funnel',
  },
  {
    path: `${adminRoute.base}${adminRoute.permissions}`,
    component: PermissionsPageAdmin,
    name: 'nav.permissions',
  },
  {
    path: `${adminRoute.base}${adminRoute.protectMode}`,
    component: ProtectModePageAdmin,
    name: 'nav.protectMode',
  },
  {
    path: `${adminRoute.base}${adminRoute.calls}`,
    component: CallsPageAdmin,
    name: 'nav.calls',
  },
  {
    path: `${adminRoute.base}${adminRoute.location}`,
    component: LocationPageAdmin,
    name: 'nav.location',
  },
  {
    path: `${adminRoute.base}${adminRoute.safetyAlerts}`,
    component: SafetyAlertsPageAdmin,
    name: 'nav.safetyAlerts',
  },
  {
    path: `${adminRoute.base}${adminRoute.errorLogs}`,
    component: ErrorLogsPageAdmin,
    name: 'nav.errorLogs',
  },
  {
    path: `${adminRoute.base}${adminRoute.supportRequests}`,
    component: SupportRequestsPageAdmin,
    name: 'nav.supportRequests',
  },
];

export const adminRouteAbsolute = {
  dashboard: `${adminRoute.base}${adminRoute.dashboard}`,
  funnel: `${adminRoute.base}${adminRoute.funnel}`,
  permissions: `${adminRoute.base}${adminRoute.permissions}`,
  protectMode: `${adminRoute.base}${adminRoute.protectMode}`,
  calls: `${adminRoute.base}${adminRoute.calls}`,
  location: `${adminRoute.base}${adminRoute.location}`,
  safetyAlerts: `${adminRoute.base}${adminRoute.safetyAlerts}`,
  errorLogs: `${adminRoute.base}${adminRoute.errorLogs}`,
  supportRequests: `${adminRoute.base}${adminRoute.supportRequests}`,
};
